module.exports = __webpack_public_path__ + "static/media/metamask.87c6904d.png";